import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ApiError, AuthService, ConfigService, DataTablesService, MessageService, GuidService } from '../../../../core';
import { ConfigEmpresa, createNomeRepresentante } from '../../../configuracoes/app/empresa';
import { TransportadoraFilter } from './transportadora-filter';
import { TransportadoraFilterCollapseComponent } from './transportadora-filter-collapse.component';
import { TransportadoraCrudHttpService } from '../services';
import { Transportadora } from '../transportadora';

@Component({
    selector: 'sgt-transportadora-filter-modal',
    templateUrl: './transportadora-filter-modal.component.html',
})
export class TransportadoraFilterModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    @Input() idModal: string;
    @Input() situacao: number; // Situação padrão
    @Output() selectEntity = new EventEmitter<Transportadora>();
    elModal: any;
    isSelectRegistered = false;

    entities: Transportadora[];
    idDataTable: string;
    dataTable: any;
    filter = new TransportadoraFilter();
    @ViewChild('filterCollapse') filterCollapse: TransportadoraFilterCollapseComponent;
    @ViewChild('modalBody') modalBody: ElementRef;


    constructor(private el: ElementRef,
                private authService: AuthService,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private transportadoraCrudHttpService: TransportadoraCrudHttpService,
                private guidService: GuidService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();

        this.create();
        this.idDataTable = this.guidService.generate();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Limpa o filtro */
    clearFilter() {
        this.filterCollapse.clear();
    }

    open() {
        this.clearFilter();
        this.createTable();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    search() {
        this.dataTable.ajax.reload();
    }

    private closeFilter() {
        this.filterCollapse.close();
        jQuery(this.modalBody.nativeElement).scrollTop(0);
    }

    private hiddenTableColumns() {
        const columns: any[] = [];
        if (this.isRepresentante) { // Se for representante, ocultamos a coluna do representante
            columns.push({visible:  false, targets: 5});
        }

        return columns;
    }

    /** Cria a Datatables assíncrona */
    createTable() {
        this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
            serverSide: true,
            processing: true,
            searching: false,
            columns: [
                {
                    data: null,
                    className: 'col-options',
                    visible: false
                },
                {data: 'pessoa.codigoIntegracaoErp', className: 'col-codigo-integracao-erp'},
                {
                    data: 'pessoa.nome',
                    className: 'col-nome',
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {
                    data: 'pessoa.nomeFantasia',
                    className: 'col-nome-fantasia',
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {data: 'pessoa.cnpjCpf', className: 'col-cnpj-cpf'},
                {
                    data: 'situacao',
                    className: 'col-situacao text-center',
                    render: (data) => {
                        switch (data) {
                            case 1:
                                return '<span class="badge badge-success">Ativa</span>';
                            case 2:
                                return '<span class="badge badge-danger">Inativa</span>';
                            default:
                                return '';
                        }
                    }
                }
            ],
            columnDefs: this.hiddenTableColumns(),
            ajax: (data, callback, settings) => { // Evento Ajax para pesquisar os Transportadoras
                this.closeFilter();
                // Se tiver a situaçõa padrão informada, sempre adicionamos ela no filtro
                if (this.situacao) {
                    this.filter.situacao = this.situacao
                }

                const order = data.order[0];
                this.filter.nomeCodigoCnpjCpf = data.search.value;
                this.transportadoraCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, order.column, order.dir)
                    .subscribe(
                        response => {
                            this.entities = response.data;
                            callback(response);
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, 'Erro ao pesquisar as transportadoras', error);
                            callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                        }
                    );
            }
        })
        .then(dataTable => {
            this.dataTable = dataTable;

            // Somente vincula o evento de clique para selecionar a entidade uma única vez
            if (!this.isSelectRegistered) {
                this.isSelectRegistered = true;

                const myself = this;
                $(`#${this.idDataTable} tbody`).on( 'click', 'tr', function() {
                    const table = ($(`#${myself.idDataTable}`) as any).DataTable();
                    const data = table.row(this).data();

                    if (data) {
                        myself.onSelectEntity(data);
                    }
                } );
            }
        });
    }

    /** Ao selecionar o Transportadora emitimos o evento de seleção e fechamos o modal */
    private onSelectEntity(entity: Transportadora) {
        this.selectEntity.emit(entity);
        this.close();
    }
}
